export default __webpack_public_path__ + "static/media/StoreViewButton.6214a914.svg";